import css from './index.module.scss';
import PropTypes from 'prop-types';
import { Button } from '@components/base';
import { useFormContext } from 'react-hook-form';
import { ISupplierDetailForm } from '@helpers/types';
import InfoFields from './info-fields';
import SupplierAddressFields from './supplier-address-fields';
import { POCDetailContainer } from '@components/common';
import { useBeforeUnloadAndNavigate } from '@helpers/hooks';
import { ISupplierFilterOptions } from '@helpers/types/supplier';

export interface SupplierDetailFormProps {
  showVendorId?: boolean;
  onFormSubmit: (data: ISupplierDetailForm) => void;
  onNextClick?: () => void;
  onCancelClick?: () => void;
  userList: Array<object>;
  onRefreshUsers?: () => void;
  enableEditMode?: boolean;
  filterOptions: ISupplierFilterOptions;
  type?: number;
}

const SupplierDetailForm = (props: SupplierDetailFormProps) => {
  const {
    onNextClick,
    showVendorId,
    onCancelClick,
    onFormSubmit,
    userList,
    onRefreshUsers,
    enableEditMode = false,
    filterOptions,
    type
  } = props;

  const {
    handleSubmit,
    formState: { isSubmitting, isDirty }
  } = useFormContext<ISupplierDetailForm>();

  useBeforeUnloadAndNavigate();

  return (
    <form className={css.formWrapper} onSubmit={handleSubmit(onFormSubmit)} noValidate>
      <InfoFields
        showVendorId={showVendorId}
        disabledSupplierName={showVendorId}
        filterOptions={filterOptions}
        type={type}
      />
      <POCDetailContainer
        enableEditMode={enableEditMode}
        userList={userList}
        onRefreshUsers={onRefreshUsers}
      />
      <SupplierAddressFields />
      <div className={css.actionButtonWrapper}>
        <Button variant="text" onClick={onCancelClick} disabled={isSubmitting}>
          Cancel
        </Button>
        <div className={css.actionButtonContainer}>
          {showVendorId && (
            <Button variant="outlined-secondary" onClick={onNextClick} disabled={isSubmitting}>
              Next
            </Button>
          )}
          <Button type="submit" disabled={isSubmitting || (showVendorId ? !isDirty : false)}>
            {showVendorId ? 'Update and Proceed' : 'Save and Proceed'}
          </Button>
        </div>
      </div>
    </form>
  );
};

SupplierDetailForm.defaultProps = {
  showVendorId: false
};

SupplierDetailForm.propTypes = {
  showVendorId: PropTypes.bool,
  onNextClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onFormSubmit: PropTypes.func.isRequired
};

export default SupplierDetailForm;
